import { Alert, Box, useTheme } from "@mui/material";
import * as React from "react";

import { useAuth } from "@/providers";
import { PageLayout } from "@/shared/components/PageLayout";

import { CollectionsView } from "./CollectionsView";

export const Collections: React.FC = () => {
  const { currentOrganization } = useAuth();

  const theme = useTheme();

  return (
    <PageLayout
      title={"Roboto - Collections"}
      headerContentLeft={"Collections"}
    >
      <div>
        <Box marginBottom={theme.spacing(3)}>
          <Alert severity="info">
            Collections are used to group datasets or files together. For
            example, you could create a collection of images for regression
            testing an algorithm.
          </Alert>
        </Box>
        <CollectionsView org={currentOrganization} />
      </div>
    </PageLayout>
  );
};
